import { render, staticRenderFns } from "./AgentCreate.vue?vue&type=template&id=7453a248&"
import script from "./AgentCreate.vue?vue&type=script&lang=js&"
export * from "./AgentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports